import React from "react";
import { Link } from "react-router-dom";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";

export default function GalleryWraps() {
  return (
    <div className="Gallery-Wraps">
      <main>
        {/* hera banner start */}
        <div
          className="tp-breadcrumb__area fix tp-breadcrumb-height"
          data-background="assets/img/breadcrumb/background-gallery.png"
          style={{
            backgroundImage: 'url("assets/img/breadcrumb/background-gallery.png")',
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tp-breadcrumb__content text-center z-index-5">
                  <h3 className="tp-breadcrumb__title">
                    Gallery <br /> Wraps
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* hero banner end */}
        {/* second content section start*/}
        <div
          className="tp-blog__area p-relative am  pt-110 pb-180"
          data-background="assets/img/breadcrumb/Group.png"
          style={{backgroundImage:"url('assets/img/breadcrumb/Group.png')", backgroundSize: "cover" }}
        >
          <div className="container">
            <div className="row text">
              <div className="col-xl-6 col-lg-5 col-md-6">
                <h4 className="text-left">
                  Museum Quality, Gallery <br /> Wraps for Home or Office{" "}
                </h4>
              </div>
              <div className="col-xl-6 col-lg-5 col-md-6 text-right"> 
                <Link className="  large head banner" >
                  Create your PRINT
                </Link>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xl-6 col-lg-6 col-md-12 mb-40  wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link>
                      <img
                        className="w-100"
                        src="assets/img/blog/left.png"
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="tp-blog__content text-center">
                    <h5 className="tp-blog__title">THICKNESS – 0.75 INCHES 
                    </h5>
                    <div className="tp-blog__meta">
                      <span>
                        Canvas is wrapped around a .75″ wood stretcher bar. All
                        frames do not have a space for a 1 1/2″ stretcher. This
                        would make it stick to far out from the wall.
                      </span>
                    </div>
                    <div className="tp-blog__link">
                      <Link>Shop 0.75 inches</Link>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-6 col-lg-6 col-md-12 mb-40  wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link>
                      <img
                        className="w-100"
                        src="assets/img/blog/right.png"
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="tp-blog__conten text-center">
                    <h5 className="tp-blog__title"> THICKNESS – 1.5 INCHES 
                    </h5>
                    <div className="tp-blog__meta">
                      <span>
                        Canvas is wrapped around a 1.5″ thick wood stretcher
                        bar. This choice creates an artistic look that enhances
                        your image and does not need a frame.
                      </span>
                    </div>
                    <div className="tp-blog__link">
                      <Link>Shop 1.5 inches</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* second content section end */}
        {/* wrapped section start */}
        <section className="  full-section main">
          <div className="container-fluid">
            <div className="row content-wraped">
              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className=" ">
                  <img
                    className="w-32"
                    src="assets/img/blog/wraped_bottom.png"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 text">
                <div className="bottom-para left pt-30 pb-30">
                  <h4>
                    Create your Gallery Wrapped Edges to Enhance the look you
                    want!
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* wraped section section end */}
        
        <UpperFooterSlider />
      </main>
    </div>
  );
}
